module.exports = __webpack_public_path__ + "static/media/foto_02.4f24e4c2.jpg";